import { render, staticRenderFns } from "./AddressProjectSpecifications.vue?vue&type=template&id=18e5d9fc&scoped=true&lang=pug&"
import script from "./AddressProjectSpecifications.vue?vue&type=script&lang=ts&"
export * from "./AddressProjectSpecifications.vue?vue&type=script&lang=ts&"
import style0 from "./AddressProjectSpecifications.vue?vue&type=style&index=0&id=18e5d9fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5d9fc",
  null
  
)

export default component.exports